import { ComponentProps } from 'react';
import {
  Image as RNImage,
  ImageSourcePropType,
  ImageURISource,
  Platform,
  View,
} from 'react-native';
import { Image as ImageWithCache } from 'react-native-expo-image-cache';

type Props = Omit<ComponentProps<typeof RNImage>, 'onError' | 'source'> & {
  source?: ImageSourcePropType;
  uri?: string;
};

export default function Image({
  style,
  source: sourceProp,
  uri: uriProp,
  ...props
}: Props) {
  const uri = (sourceProp as ImageURISource)?.uri || uriProp;
  const commonProps = { style, ...props };

  if (uri && Platform.OS !== 'web') {
    return (
      <ImageWithCache
        transitionDuration={300}
        tint="light"
        uri={uri}
        {...commonProps}
      />
    );
  }

  if (uri) {
    return <RNImage source={{ uri }} {...commonProps} />;
  }
  if (sourceProp) {
    return <RNImage source={sourceProp} {...commonProps} />;
  }
  return <View {...commonProps} />;
}
